import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { Card, Button, Table, Form, Col, Row, Popover, OverlayTrigger, FormGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useRef, useState } from "react";
import { addOrUpdateUser, getUserRoleList, searchUser, selectPageNode, grantOrRemovePermission, GrantFullPermission, deleteUser, findPagePath, copyUserPermission, getUserList4Modal } from "../store/api/Users";
import {
    CheckLg, PencilFill, CaretRightFill, CaretLeftFill, DashCircle, PlusSquare, Trash, LockFill, List, PersonLinesFill, Tools,
    CalculatorFill, EnvelopeOpenFill, DisplayFill, GearWideConnected, ArrowLeftSquare, CheckAll, Search, FileEarmarkPost,
    Files
} from "react-bootstrap-icons";
import { setDialog } from "../store/api/GetAllProduct";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import TreeViewItem from "../../Components/TreeViewItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faUserPlus, faUsersCog } from "@fortawesome/free-solid-svg-icons";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import { enforceMinMax } from "../../store/api/CommonFunctions";

const UserManagement = () => {
    const currPage = useRef(1);
    const totalPage = useRef(0);
    let currentRole = useRef([]);
    const searchData = useRef({});
    const dispatch = useDispatch();
    const changedItems = useRef([]);
    const permissionUserID = useRef();
    const inputSearchPermission = useRef();
    const inputSourceUserForCopy = useRef();
    const [userInfo, setUserInfo] = useState(null);
    const [showInfo, setShowInfo] = useState(false);
    const [isPending, setPending] = useState(false);
    const [selectingUserList, setSelectingUserList] = useState([]);
    const { register, handleSubmit, errors } = useForm();
    const [showPermission, setShowPermission] = useState(false);
    const [foundPermissions, setFoundPermissions] = useState([]);
    const { roleList, userList } = useSelector(state => {
        return {
            roleList: state.UserReducer.userRoleList,
            userList: state.UserReducer.userList
        }
    });
    if (totalPage.current < 1) {
        const t = userList && userList.TotalCount ? Number(userList.TotalCount) : 0;
        totalPage.current = Math.floor(t / 10) + ((t % 10) > 0 ? 1 : 0);
    }
    const popSelectUser = (
        <Popover style={{ fontFamily: "Vazir", minWidth:"200px" }}>
            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faFileExport} size="lg"/>&nbsp;
                کپی دسترسی
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                {Array.isArray(selectingUserList) &&
                    <FormGroup>
                        <select className="form-control" ref={inputSourceUserForCopy}>
                            <option value="">انتخاب کنید</option>
                            {selectingUserList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                        </select>
                    </FormGroup>
                }
                <Button className="group-Btn mt-2" onClick={copyPermission}><Files size={18}/>کپی دسترسی</Button>
            </Popover.Content>
        </Popover>
    )
    const search = (reset, e) => {
        if (e?.key && e.key !== "Enter") {
            return;
        }
        if (reset) {
            totalPage.current = 0;
            currPage.current = 1;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.Take = 10;
        dispatch(searchUser(searchData.current));
    }
    function copyPermission()
    {
        const selected = inputSourceUserForCopy.current.value;
        if(!(Number(selected) > 0))
        {
            setErrorDialog(dispatch, "کاربری انتخاب نشده است", "کپی دسترسی");
            return;
        }
        const onCopyDone = (res)=>{
            if(res.Error)
            {
                setErrorDialog(dispatch, res.Error, "کپی دسترسی");
            }
            else if(res.Data)
            {
                setErrorDialog(dispatch,"success","کپی دسترسی");
            }

        }
        copyUserPermission(selected, userInfo.ID, onCopyDone);
    }
    const goToEditMode = (user) => {
        if (user.RoleList && user.RoleList !== "") {
            currentRole.current = user.RoleList.replace(/,,/g, ",").split(",");//.map(Number);
        }
        setUserInfo(user);
        setShowInfo(true);
    }
    const goToInsertMode = () => {
        setShowInfo(true);
    }
    const cancelUser = () => {
        currentRole.current = [];
        setUserInfo({});
        setShowInfo(false);
    }
    const cancelPermission = () => {
        changedItems.current = [];
        setShowPermission(false);
        setFoundPermissions([]);
    }
    const addRemoveRole = (item) => {
        if (!currentRole.current) {
            currentRole.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            if (!currentRole.current.includes(splited)) {

                currentRole.current.push(...splited);
            }
        }
        else {
            currentRole.current = currentRole.current.filter(a => !splited.includes(a));
        }
        // if (add) {
        //     if (!currentRole.current.includes(id))
        //         currentRole.current.push(id);
        // }
        // else {
        //     currentRole.current = currentRole.current.filter(r => r !== id);
        // }
    }
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        search();
    }
    const onSubmit = (data) => {
        if (data.Password !== data.DupPassword) {
            setErrorDialog(dispatch, "گذرواژه و تکرار آن باید همسان باشد", "ثبت اطلاعات");
            return;
        }
        if (Array.isArray(data.IsActive) && data.IsActive.includes('on')) {
            data.IsActive = true;
        }
        if (userInfo) {
            data.ID = userInfo.ID;
        }
        if (currentRole.current && currentRole.current.length > 0) {
            data.RoleList = currentRole.current.filter(r => r !== 0).join(",");
            data.RoleList = "," + data.RoleList.replace(/,/g, ",,") + ",";
        }
        const onSuccess = () => {
            setPending(false);
            search(true);
            currentRole.current = [];
            setUserInfo({});
            setShowInfo(false);
        }
        setPending(true);
        dispatch(addOrUpdateUser(data, onSuccess));
    }
    const showPermissionList = (userID) => {
        permissionUserID.current = userID
        setShowPermission(true);
    }
    const nodeClick = (el) => {
        const elArray = document.querySelectorAll(".clickedNode");
        elArray.forEach(el => el.classList.remove("clickedNode"));
        el.classList.add('clickedNode');
    }
    const submitPermission = () => {
        if (changedItems.current.length === 0) {
            setShowPermission(false);
            return;
        }
        const onSuccess = () => {
            setShowPermission(false);
            changedItems.current = [];
        }
        dispatch(grantOrRemovePermission(changedItems.current, onSuccess));
    }
    const grantAll = () => {
        const onSuccess = () => {
            setShowPermission(false);
            changedItems.current = [];
        }
        dispatch(GrantFullPermission(permissionUserID.current, onSuccess));
    }
    function findPath(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        const name = inputSearchPermission.current.value;
        if (name === "") {
            setFoundPermissions([]);
            return;
        }
        findPagePath(name, setFoundPermissions);
    }

    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getUserRoleList());
        search();
        getUserList4Modal("",setSelectingUserList);
    }, []);
    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">
                <FontAwesomeIcon icon={faUsersCog} size="lg" />&nbsp; مدیریت کاربران</Card.Header>
            <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                {showPermission && !showInfo &&
                    <Fragment>
                        <TreeViewItem hasPanel={true} changedItems={changedItems} userID={permissionUserID.current} title="دسترسی ها" displaySubItems={{ fn: selectPageNode, canDispatch: false }} items={[
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "مشتریان", id: 7, name: 'CRM', icon: <PersonLinesFill size={16} />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "امور مالی", name: "Finances", icon: <CalculatorFill size={16} color="#97055a" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "فروش و انبار", name: "SaleAndStorage", icon: <FileEarmarkPost size={16} color="#1098ac" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "اتوماسیون اداری", id: 3, name: 'OfficeAutomation', icon: <EnvelopeOpenFill size={15} color="#116592" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "خدمات پس از فروش", id: 6, name: 'AfterSalesService', icon: <Tools size={15} color="#d45006" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "مانیتورینگ و مدیریت", id: 9, name: 'Management', icon: <DisplayFill size={15} color="#9c399c" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "تنظیمات و تعاریف عمومی", id: 1, name: 'GeneralSettings', icon: <GearWideConnected size={15} color="#0937ad" />
                            }
                        ]} />
                        <div className="rowBorder" style={{ padding: "8px" }}>
                            <Col md={4} className="mt-1 form-group">
                                <Form.Control ref={inputSearchPermission} placeholder="نام صفحه مورد جستجو" onKeyDown={findPath} />
                                <Button className="btn-input-tiny" style={{ top: "4px", left: "3px" }} onClick={findPath}><Search size={20} /></Button>
                            </Col>
                            <div style={{ padding: "5px" }}>
                                {foundPermissions?.Data && Array.isArray(foundPermissions.Data) &&
                                    foundPermissions.Data.map((item, i) => <div key={i}>{item}</div>)}
                            </div>
                        </div>
                        <div className="mt-2">
                            <Button variant="success" className="group-Btn" onClick={submitPermission}><CheckLg />&nbsp;ثبت تغییرات</Button>
                            <Button className="group-Btn" onClick={grantAll}><CheckAll size={19} />&nbsp;دسترسی کامل</Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelPermission}><ArrowLeftSquare size={18} />&nbsp;بازگشت به لیست</Button>
                        </div>
                    </Fragment>
                }
                {showInfo && !showPermission &&
                    <form onSubmit={handleSubmit(onSubmit)} readOnly>
                        <div className="row" style={{ border: "1px solid #b1abab", borderRadius: "3px", paddingBottom: "10px", margin: 0 }}>
                            <div className="form-group col-md-2">
                                <label>نام کامل</label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                                <input type="text" className="form-control" name="Name" defaultValue={userInfo?.Name} ref={register({ required: true })} />
                                {errors.Name && <small className="errors">وارد کردن نام الزامی است</small>}
                            </div>
                            <div className="form-group col-md-2">
                                <label>نام کاربری</label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                                <input type="text" className="form-control" name="UserName" defaultValue={userInfo?.UserName} ref={register({ required: true })} />
                                {errors.UserName && <small className="errors">وارد کردن نام کاربری الزامی است</small>}
                            </div>
                            <div className="form-group col-md-2">
                                <label>گذرواژه</label>
                                <input type="password" name="Password" className="form-control" ref={register({ required: !userInfo || !userInfo.ID })} />
                                {errors.Password && <small className="errors">وارد کردن گذرواژه الزامی است</small>}
                            </div>
                            <div className="form-group col-md-2">
                                <label>تکرار گذرواژه</label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                                <input type="password" name="DupPassword" className="form-control" ref={register({ required: !userInfo || !userInfo.ID })} />
                                {errors.DupPassword && <small className="errors">وارد کردن تکرار گذرواژه الزامی است</small>}
                            </div>
                            <div className="form-group col-md-2">
                                <label>شماره داخلی</label>
                                <input type="text" className="form-control" name="CRMLineNumber" defaultValue={userInfo?.CRMLineNumber} ref={register({})} />
                            </div>
                            <Col md={2} className="form-group">
                                <label>صفحه اصلی</label>
                                <Form.Control as="select" name='HomePage' defaultValue={userInfo?.HomePage ?? ""} ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="Accounting">سیستم حسابداری</option>
                                    <option value="CRM">سیستم مشتریان</option>
                                    <option value="Office">سیستم اتوماسیون</option>
                                    <option value="Sale">سیستم فروش و انبار</option>
                                    <option value="Services">سیستم خدمات پس از فروش</option>
                                </Form.Control>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>آغاز ساعت کار:</label>
                                <Form.Control type="number" name="AllowedWorkingHourFrom" defaultValue={userInfo?.AllowedWorkingHourFrom ?? ""} ref={register({})} min={0} onKeyUp={enforceMinMax} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>پایان ساعت کار:</label>
                                <Form.Control type="number" name="AllowedWorkingHourTo" defaultValue={userInfo?.AllowedWorkingHourTo ?? ""} ref={register({})} max={24} onKeyUp={enforceMinMax} />
                            </Col>
                            <div className="form-group col-md-2">
                                <label>&nbsp;</label>
                                <div className="mt-1" style={{ border: "1px solid gray", borderRadius: "3px", height: "35px", padding: "6px" }}>
                                    <input type="checkbox" name="IsActive" className="form-check-input" ref={register()} defaultChecked={userInfo && userInfo.IsActive !== undefined ? userInfo.IsActive : true} />
                                    &nbsp;
                                    <label style={{ color: "blue", marginTop: "2px" }}>فعال است</label>
                                </div>
                            </div>
                            <div className="form-group col-md-2">
                                <label>لیست نقش ها</label>
                                <BihamtaMultiSelect dataSource={roleList} valueItem="RoleID" displayItem="RoleName" onItemCheckChanged={addRemoveRole} defaultCheckedList={currentRole.current} />
                            </div>
                            <div>
                                <Button type="submit" variant="success" style={{ float: "right" }} className="mt-2 group-Btn">{!isPending && <Fragment><CheckLg />&nbsp;ثبت اطلاعات</Fragment>}{isPending && <Loader type="BallTriangle" color="white" height={20} width={20} />}</Button>
                                <Button variant="danger" style={{ float: "right" }} className="mt-2 group-Btn" onClick={cancelUser}><DashCircle size={16} />&nbsp;انصراف</Button>
                                {Number(userInfo?.ID) > 0 &&
                                    <OverlayTrigger overlay={popSelectUser} trigger="click">
                                        <Button variant="info" className="mt-2 group-Btn"><Files size={18} />&nbsp;کپی دسترسی</Button>
                                    </OverlayTrigger>
                                }
                            </div>
                        </div>
                    </form>
                }
                {!showInfo && !showPermission &&
                    <Button className="group-Btn-smalll" title="کاربر جدید" onClick={goToInsertMode}><FontAwesomeIcon icon={faUserPlus} size="2x" /></Button>
                }
                {!showInfo && !showPermission &&
                    <Row className="mt-0">
                        <Col md={3} className="form-group">
                            <Form.Control placeholder="نام کامل" defaultValue={searchData.current.Name ? searchData.current.Name : ""}
                                onChange={e => searchData.current.Name = e.target.value} onKeyDown={e => search(true, e)} />
                        </Col>
                        <Col md={3} className="form-group">
                            <Form.Control placeholder="نام کاربری" defaultValue={searchData.current.UserName ? searchData.current.UserName : ""}
                                onChange={e => searchData.current.UserName = e.target.value} onKeyDown={e => search(true, e)} />
                        </Col>
                        <Col md={2} className="form-group">
                            <Button variant="secondary" className="group-Btn" style={{ marginTop: "3px" }} onClick={() => search(true)}><Search size={16} />&nbsp;جستجوی کاربر</Button>
                        </Col>
                    </Row>
                }
                {!showPermission &&
                    <Fragment>
                        <Table className="mt-2">
                            <thead>
                                <tr>
                                    <th>نام و نام خانوادگی</th>
                                    <th>نام کاربری</th>
                                    <th>نقش ها</th>
                                    <th style={{ width: "50px" }}>فعال</th>
                                    <th style={{ width: "100px" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    userList === "PENDING" &&
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center", width: "100%" }}>
                                            <Loader type="BallTriangle" width={30} height={30} color="#bb1370" />
                                        </td>
                                    </tr>
                                }
                                {userList?.Data && Array.isArray(userList.Data) &&
                                    userList.Data.map((item, i) =>
                                        <tr key={i} className="resultTableRow">
                                            <td>{item.Name}</td>
                                            <td>{item.UserName}</td>
                                            <td style={{ maxWidth: "300px" }}>{item.RoleNameList}</td>
                                            <td style={{ width: "50px" }}><input type="checkbox" className="form-check-input" readOnly checked={item.IsActive} /></td>
                                            <td style={{ width: "100px" }}>
                                                <PencilFill className="rowBtn" color="#da6e0d" size={16} onClick={() => goToEditMode(item)} />
                                                &nbsp;
                                                <Trash color="red" size={16} className="rowBtn" onClick={() => {
                                                    dispatch(setDialog({
                                                        status: 'show',
                                                        arrayBtn: ['yes', 'no'],
                                                        dialogTitle: 'حذف کاربر',
                                                        dialogText: 'آیا از حذف مطمئن هستید؟',
                                                        okOperation: deleteUser(item.ID, search)
                                                    }))
                                                }} />
                                                &nbsp;&nbsp;
                                                <span className="rowBtn" onClick={() => showPermissionList(item.ID)}>
                                                    <LockFill size={16} color="#910766" /><List className="scaleIcon" size={14} color="#910766" />
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                        <div style={{ textAlign: "center" }}>
                            <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                            <span>{currPage.current + " از " + totalPage.current}</span>{userList && userList.TotalCount && <span style={{ color: "gray" }}>&nbsp;({userList.TotalCount})</span>}
                            <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage.current} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                        </div>
                    </Fragment>
                }
            </Card.Body>
        </Card>
    </div >
    )
}
export default UserManagement;